module.exports = __webpack_public_path__ + "media/app_search/Billing/assets/credit_cards/discover-13b1c4334f8a73113b70cfcdd140fd0c.svg";